import { describeExternalPaymentSource } from '../utils/payment-settings-labels.util';
import {
  PaymentSettingsEditor,
  type PaymentSettingsTab,
} from './payment-settings-editor.component';
import { PaymentSettingsExternalNotice } from './payment-settings-external-notice.component';

type PaymentSettingsProductProps = {
  productCode: string;
  tab: PaymentSettingsTab;
  onTabChange: (_tab: PaymentSettingsTab) => void;
};

/**
 * A página de um produto na tela de formas de pagamento: o editor, ou só o
 * aviso de onde ficam as formas quando o produto as define fora do Portal
 * (`paymentMethodsSource` do `products.config.ts`) — nesse caso nada é lido
 * nem gravado aqui.
 */
export function PaymentSettingsProduct({
  productCode,
  tab,
  onTabChange,
}: PaymentSettingsProductProps) {
  const external = describeExternalPaymentSource(productCode);

  if (external) {
    return (
      <PaymentSettingsExternalNotice
        productCode={productCode}
        productName={external.productName}
        label={external.label}
        description={external.description}
      />
    );
  }

  return (
    <PaymentSettingsEditor
      productCode={productCode}
      tab={tab}
      onTabChange={onTabChange}
    />
  );
}
